import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { AcceptRulesRequest, AcceptRulesResponse, PartnerRulesResponse } from "@mfa-aff/shared";
import { acceptRulesMock, rulesMock } from "../mocks/rules";
import { get, send } from "./client";
import { meKey } from "./me";
import { partnerPaths } from "./paths";

export const rulesKey = ["partner", "rules"] as const;

/** `GET /rules`: rule book in force, announced versions, history and announced rate-card changes. */
export const useRules = () => useQuery({ queryKey: rulesKey, queryFn: () => get<PartnerRulesResponse>(partnerPaths.rules, rulesMock) });

/** `POST /rules/accept {version}`; `version` must be `me.rules.currentVersion` (the rule book in force). */
export const useAcceptRules = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body: AcceptRulesRequest) => send<AcceptRulesResponse>("POST", partnerPaths.rulesAccept, body, () => acceptRulesMock(body)),
        onSuccess: () => {
            void qc.invalidateQueries({ queryKey: rulesKey });
            void qc.invalidateQueries({ queryKey: meKey });
        },
    });
};
